import { Page } from '@/components/layout/page';

export default function HomePage() {
    return (
        <Page title="Les informations officielles des entreprises">
            <></>
        </Page>
    );
}